import { StepInput } from '../../shared/StepInput'
import { useRecurrencePeriodProps } from './useRecurrencePeriodProps'

export function RecurrencePeriod() {
  const props = useRecurrencePeriodProps()

  return <StepInput {...props} />
}
